import { ChevronLeft, ChevronRight } from '@styled-icons/material-outlined';
import { Dispatch, SetStateAction } from 'react';
import styled from '@emotion/styled';
import { IPaginationProps } from './types';

const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  color: var(--text);
`;

const PaginationActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

const PaginationActionButton = styled.button((props) => `
    background: unset;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    border: 1px solid var(--color-border-light);
    color: var(--text);
    display: grid;
    place-items: center;
    cursor: pointer;
    opacity: ${props?.disabled ? '1' : '0.6'};
  `);

export function Pagination({
  totalItems,
  descriptionTotal = 0,
  page,
  setpage,
}: {
  totalItems: number,
  descriptionTotal?: number,
  page: IPaginationProps,
  setpage: Dispatch<SetStateAction<IPaginationProps>>
}) {
  return (
    <PaginationContainer>
      <div>
        Showing
        {' '}
        {page.offset + 1}
        -
        {page.size + page.offset > totalItems ? totalItems : page.size + page.offset}
        {' '}
        of
        {' '}
        {descriptionTotal || totalItems}
        {' '}
        results
      </div>

      <PaginationActionsContainer>
        <PaginationActionButton
          type="button"
          disabled={page.offset - page.size < 0}
          onClick={() => setpage((curr) => ({ ...curr, offset: page.offset - page.size }))}
        >
          <ChevronLeft size={20} />
        </PaginationActionButton>

        <PaginationActionButton>
          {page.offset / page.size + 1}
        </PaginationActionButton>
        {/* {
            pageNumbers.length < 4 && pageNumbers.map((val) => (
              <div className={classNames(styles.tablePaginationPageAction, {
                [styles.tablePaginationPageActionActive]: val.offset === page.offset,
              })}
              >
                {val.label}
              </div>
            ))
          } */}

        <PaginationActionButton
          type="button"
          disabled={page.offset + page.size >= totalItems}
          onClick={() => setpage((curr) => ({ ...curr, offset: page.offset + page.size }))}
        >
          <ChevronRight size={20} />
        </PaginationActionButton>
      </PaginationActionsContainer>
    </PaginationContainer>

  );
}
